/* 案件一覧(申込人)のアコーディオン */
import React, { useState } from 'react';
import { Collapse, Card } from 'react-bootstrap';
import Heading from './Heading';
import ProcedureStep from './ProcedureStep';
import { contract_type } from '../Const';
import axios from 'axios';
import { fileDownload } from '../FileDownload';
import LoadingModal from '../molecules/LoadingModal';
import ConfirmContractModal from './ConfirmContractModal';
import {
  isBrowserIOSSafari,
  isBrowserIpadSafari,
  isIOSsafariChromeOrPcSafari,
  isBrowserIe,
} from '../BrowserJudgment';
import { releaseBrowserBack } from '../BrowserBack';
import { getContractName } from '../Common';
interface Props {
  name: string;
  r_id: string;
  r_cd: string;
  date: string;
  loan_name: string;
  loan_css: string;
  relationship: string;
  current: number;
  status: number;
  agri_fund_name: string;
  contract_method: string;
  contracts: string[];
  exists_contract: boolean;
  is_open: boolean;
  show_reception_btn?: boolean;
}

interface ContractDocument {
  id: number;
  contract_name: string;
  file_name: string;
  base64: string;
}

interface ContractDocumentResponse {
  id: number;
  contract_name: string;
  file_name: string;
}

const ProjectShelf: React.FC<Props> = ({
  name,
  r_id,
  r_cd,
  date,
  loan_name,
  loan_css,
  relationship,
  current,
  status,
  agri_fund_name,
  contract_method,
  contracts,
  exists_contract,
  is_open,
  show_reception_btn,
}) => {
  const [is_accordion_open, setIsAccordionOpen] = useState(is_open);
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);
  //  アコーディオンを開閉する
  const toggleAccordion = () => {
    setIsAccordionOpen(!is_accordion_open);
  };
  const [modal_open, setModalOpen] = useState(false);
  const [reception_id, setReceptionId] = useState('');
  const [contract_document, setContractDocument] = useState<ContractDocument[]>([]);
  const [active_document, setActiveDocument] = useState<ContractDocument>();
  // ダウンロードボタンの活性・非活性制御 true:非活性 false:活性
  const [is_download_disabled, setIsDownloadDisabled] = useState<boolean>();

  // 契約書確認モーダルを開く
  const handleClickModalOpen = (r_id: string) => {
    setModalOpen(true);
    setReceptionId(r_id);
    getDocument(r_id);
  };

  // 契約書確認モーダルを閉じる
  const handleClickModalClose = () => {
    setModalOpen(false);
    setReceptionId('');
  };

  // 表示する契約書情報の取得
  const getDocument = async (r_id: string) => {
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_contract_document`,
        {
          params: { r_id: r_id },
        }
      );
      setContractDocument(response.data);
      changeDocument(response.data[0]);
      setIsDownloadDisabled(false);
    } catch (error) {
      console.error(error);
      setIsDownloadDisabled(true);
      alert(error.response.data.message);
    }
  };

  // ラジオボタンの選択、初回表示する書類の設定
  const changeDocument = async (document: ContractDocument) => {
    // 表示するPDFの変更
    setActiveDocument(document);

    // 表示するPDFを「確認済み」にする
    try {
      await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/confirmed_document`, {
        r_id: reception_id,
        document_id: document.id,
      });
    } catch (error) {
      console.log(error);
      alert(error.response.data.message);
    }
  };

  // 契約書確認モ―ダルの「ダウンロード」ボタン押下時
  const handleClickModalDownloadDocument = () => {
    try {
      //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
      if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
        releaseBrowserBack();
      }

      // 契約書名を取得
      const file_name = getContractName(active_document?.contract_name);
      // ファイルダウンロード
      execfileDownLoad(active_document?.id, file_name);
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  // 契約書ダウンロード処理（モーダルなし）
  const downloadDocument = async (r_id: string) => {
    try {
      setIsLoading(true);

      // ダウンロードする契約書の案件書類を取得
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_contract_files`,
        {
          params: {
            r_id: r_id,
          },
        }
      );

      // note IEの場合は非同期でDLさせないと、複数ファイルDLできない
      if (isBrowserIe()) {
        // 案件書類ID毎にダウンロード処理を行う
        const res = await axios.all(
          response.data.detail.files.map(async (file: ContractDocumentResponse) => {
            return axios.get(
              `${location.origin}${process.env.MIX_MOCK_URL}/api/download_contract_document`,
              { params: { file_id: file.id }, responseType: 'blob' }
            );
          })
        );

        res.map(async (r: any) => {
          await fileDownload(r.data, r.headers['content-disposition'], r.headers['content-type']);
        });
      } else {
        // 案件書類ID毎にダウンロード処理を行う
        response.data.detail.files.map((file: ContractDocumentResponse) => {
          // 契約書名を取得
          const file_name = getContractName(file.contract_name);
          // ファイルダウンロード
          execfileDownLoad(file.id, file_name);
        });
      }
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * ファイルをダウンロードする
   *
   * @param {number | undefined} id 契約書ID
   * @param {string} file_name DLされるファイル名
   */
  const execfileDownLoad = (id: number | undefined, file_name: string) => {
    const url = `${location.origin}${process.env.MIX_MOCK_URL}/api/download_contract_document?file_id=${id}`;
    const self_download_link = document.createElement('a');
    document.body.appendChild(self_download_link);
    self_download_link.download = `${file_name}.pdf`;
    self_download_link.href = url;
    self_download_link.click();
    self_download_link.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <Card className="shelf my-3 px-0 col-12">
      <Card.Header
        className={`shelf-header ${is_accordion_open && 'is-open'} ${loan_css}`}
        onClick={() => toggleAccordion()}
      >
        {loan_name}
        <span className="application-date">{`申込日:${date}`}</span>
        <span className={`ac-icon ${loan_css}`}></span>
      </Card.Header>
      <Collapse className="collapse-body" in={is_accordion_open}>
        <div>
          <Card.Body className="p-2">
            <div className="ad-content">
              {/* NOTE 「お申込み状況一覧」タブに表示する案件のみ「申込内容の確認をする」ボタンを表示する */}
              {show_reception_btn && (
                <div className="data-box">
                  <Heading label="申込内容" size="s" css_class={`dot_line ${loan_css}`} />
                  <dl className="data-box-list dot-line">
                    <dt>申込内容</dt>
                    <dd>
                      <a
                        href={`${location.origin}${process.env.MIX_MOCK_URL}/mypage/set_r_type_id?r_type_id=3&r_id=${r_id}`}
                        className="btn-s btn-green arrow-right-small"
                      >
                        申込内容の確認をする
                      </a>
                    </dd>
                  </dl>
                </div>
              )}
              <div className="data-box">
                <Heading label="契約状態" size="s" css_class={loan_css} />
                <ProcedureStep loan_css={loan_css} current={current} />
              </div>
              <div className="data-box">
                <Heading label="契約内容" size="s" css_class={`dot_line ${loan_css}`} />
                <dl className="data-box-list dot-line">
                  <dt>管理番号</dt>
                  <dd>{r_cd}</dd>
                </dl>
                {loan_name === '農業資金' ? (
                  <dl className="data-box-list dot-line">
                    <dt>資金の内容</dt>
                    <dd>{agri_fund_name}</dd>
                  </dl>
                ) : (
                  <dl className="data-box-list dot-line">
                    <dt>お申込みローン</dt>
                    <dd>{loan_name}</dd>
                  </dl>
                )}
                <dl className="data-box-list dot-line">
                  <dt>お申込人</dt>
                  <dd>{name}</dd>
                </dl>
                <dl className="data-box-list dot-line">
                  <dt>お申込人との関係</dt>
                  <dd>{relationship}</dd>
                </dl>
                {/* ステータスが「契約申込」以降であれば表示 */}
                {/* NOTE 契約申込以降、契約書登録済であればexists_contractがtrueで入る */}
                {exists_contract &&
                  // 電子契約か書面契約で表示の切替
                  (contract_method === contract_type.econtract ? (
                    Object.values(contracts).map((cr_id, index) => {
                      return (
                        <dl className="data-box-list dot-line" key={index}>
                          <dt>{`契約(${index + 1})`}</dt>
                          <dd className="btn-area">
                            <a
                              href={`${location.origin}${process.env.MIX_MOCK_URL}/confirm_contract?r_id=${cr_id}`}
                              className="btn-s btn-white btn-contract"
                            >
                              契約書開示
                            </a>
                            <div
                              className="btn-s btn-white btn-download"
                              onClick={() => {
                                isIOSsafariChromeOrPcSafari()
                                  ? handleClickModalOpen(cr_id)
                                  : downloadDocument(cr_id);
                              }}
                            >
                              ダウンロード
                            </div>
                          </dd>
                        </dl>
                      );
                    })
                  ) : (
                    <dl className="data-box-list dot-line">
                      <dt>契約(1)</dt>
                      <dd>※書面での契約のためWebからは契約書を確認できません</dd>
                    </dl>
                  ))}
              </div>
            </div>
          </Card.Body>
        </div>
      </Collapse>
      <ConfirmContractModal
        toggleShow={modal_open}
        contract_document={contract_document}
        active_document={active_document}
        is_download_disabled={is_download_disabled}
        toggleClose={handleClickModalClose}
        handleChange={changeDocument}
        handleClick={handleClickModalDownloadDocument}
      />
      <LoadingModal show={is_loading} />
    </Card>
  );
};

export default ProjectShelf;
